import { render, staticRenderFns } from "./icon-warning.vue?vue&type=template&id=7d2a5fd0&"
import script from "./icon-warning.vue?vue&type=script&lang=js&"
export * from "./icon-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports